import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { Link } from "../../custom_components/components/library/link";
import { LinkButton } from "../../custom_components/components/library/button";
import { Row } from "../../custom_components/components/library/container";
import { trackNewsletter, trackMembership } from "../../custom_components/components/library/tracking";
const footerTop = ()=>/*#__PURE__*/ _jsxs("div", {
        className: "footer__top",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "footer__container container--mg align--center",
                children: /*#__PURE__*/ _jsxs(Row, {
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-xs-12 col-md-4",
                            children: /*#__PURE__*/ _jsx("div", {
                                className: "footer__column",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "footer__inner",
                                    children: [
                                        /*#__PURE__*/ _jsx("h2", {
                                            className: "footer__title title--s",
                                            children: "Altijd op de hoogte"
                                        }),
                                        /*#__PURE__*/ _jsx("p", {
                                            className: "footer__text",
                                            children: "Mis niks van de laatste ontwikkelingen uit jouw bibliotheek! Schrijf je in voor de nieuwsbrief en ontvang leestips, het laatste nieuws en de leukste activiteiten."
                                        }),
                                        /*#__PURE__*/ _jsx(LinkButton, {
                                            className: "footer__button",
                                            route: "/nieuwsbrief",
                                            handle: ()=>trackNewsletter(),
                                            children: /*#__PURE__*/ _jsx("span", {
                                                className: "button__label",
                                                children: "Aanmelden nieuwsbrief"
                                            })
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-xs-12 col-md-4",
                            children: /*#__PURE__*/ _jsx("div", {
                                className: "footer__column",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "footer__inner",
                                    children: [
                                        /*#__PURE__*/ _jsx("h2", {
                                            className: "footer__title title--s",
                                            children: "Als lid kun je meer"
                                        }),
                                        /*#__PURE__*/ _jsx("p", {
                                            className: "footer__text",
                                            children: "Kies uit een groot aantal boeken, e-books, luisterboeken, cursussen, activiteiten en meer. Als lid kun je volop lezen, leren en lenen."
                                        }),
                                        /*#__PURE__*/ _jsx(LinkButton, {
                                            className: "footer__button",
                                            route: "/lidmaatschap",
                                            handle: ()=>trackMembership(),
                                            children: /*#__PURE__*/ _jsx("span", {
                                                className: "button__label",
                                                children: "Word lid"
                                            })
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-xs-12 col-md-4",
                            children: /*#__PURE__*/ _jsx("div", {
                                className: "footer__column footer__social",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "footer__inner",
                                    children: [
                                        /*#__PURE__*/ _jsx("h2", {
                                            className: "footer__title title--s",
                                            children: "Volg ons"
                                        }),
                                        /*#__PURE__*/ _jsx("p", {
                                            className: "footer__text",
                                            children: "Via onze social media kanalen volg je wat er allemaal gebeurt in de bieb."
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "footer__socials",
                                            children: [
                                                /*#__PURE__*/ _jsxs(Link, {
                                                    className: "button button--primary button--icon",
                                                    url: "https://nl-nl.facebook.com/bibliotheek.kennemerwaard",
                                                    title: "Facebook",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("span", {
                                                            className: "sr-text",
                                                            children: "Facebook"
                                                        }),
                                                        /*#__PURE__*/ _jsx("svg", {
                                                            className: "button__icon social__icon",
                                                            width: "24",
                                                            height: "24",
                                                            "aria-hidden": "true",
                                                            children: /*#__PURE__*/ _jsx("use", {
                                                                xlinkHref: "#icon--facebook"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs(Link, {
                                                    className: "button button--primary button--icon",
                                                    url: "https://nl.linkedin.com/company/bibliotheek-kennemerwaard",
                                                    title: "LinkedIn",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("span", {
                                                            className: "sr-text",
                                                            children: "LinkedIn"
                                                        }),
                                                        /*#__PURE__*/ _jsx("svg", {
                                                            className: "button__icon social__icon",
                                                            width: "24",
                                                            height: "24",
                                                            "aria-hidden": "true",
                                                            children: /*#__PURE__*/ _jsx("use", {
                                                                xlinkHref: "#icon--linkedin"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs(Link, {
                                                    className: "button button--primary button--icon",
                                                    url: "https://www.instagram.com/biebkennemerwaard/",
                                                    title: "Instagram",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("span", {
                                                            className: "sr-text",
                                                            children: "Instagram"
                                                        }),
                                                        /*#__PURE__*/ _jsx("svg", {
                                                            className: "button__icon social__icon",
                                                            width: "24",
                                                            height: "24",
                                                            "aria-hidden": "true",
                                                            children: /*#__PURE__*/ _jsx("use", {
                                                                xlinkHref: "#icon--instagram"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs(Link, {
                                                    className: "button button--primary button--icon",
                                                    url: "https://www.youtube.com/user/Kennemerwaard",
                                                    title: "YouTube",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("span", {
                                                            className: "sr-text",
                                                            children: "YouTube"
                                                        }),
                                                        /*#__PURE__*/ _jsx("svg", {
                                                            className: "button__icon social__icon",
                                                            width: "24",
                                                            height: "24",
                                                            "aria-hidden": "true",
                                                            children: /*#__PURE__*/ _jsx("use", {
                                                                xlinkHref: "#icon--youtube"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("img", {
                className: "footer__logo",
                src: "/bkw/images/bkw/logo-aanzet.svg",
                alt: "",
                width: "100",
                height: "100",
                "aria-hidden": "true",
                loading: "lazy"
            })
        ]
    });
export default footerTop;
